import {useState, useEffect  } from "react";

// Chakra imports
import { Flex, FormControl, FormLabel, Spinner, SimpleGrid, Button, LightMode, useColorModeValue , Icon, Image } from '@chakra-ui/react';

import ClientesUsuarioSelect from 'components/select/ClientesUsuarioSelect';
import DateRangeSelect from 'components/select/DateRangeSelect';
import OperacionSelect from 'components/select/OperacionSelect';
import OficinaSelect from 'components/select/OficinaSelect';
import EmbarqueSelect from 'components/select/EmbarqueSelect';

import InputField from "components/fields/InputField";

import { RiFileExcel2Line, RiSearch2Line } from 'react-icons/ri';

import { useWebTrackingStore } from 'store/webTrackingStore';

import { MODULO_WEB_TRACKING } from "const/CommonConst";

import tracking from 'assets/img/tracking.png';

export default function Actions(props: {
	[x: string]: any;
	onChange: any;
	onExport: any;
	disabledActions: boolean;
	showProgressSearch: boolean;
	showProgressExport: boolean;
}) {
	
	const cliente = useWebTrackingStore(state => state.cliente)
	const fechaInicio = useWebTrackingStore(state => state.fechaInicio)
	const fechaFin = useWebTrackingStore(state => state.fechaFin)
	const embarque = useWebTrackingStore(state => state.embarque)
	const oficina = useWebTrackingStore(state => state.oficina)
	const expediente = useWebTrackingStore(state => state.expediente)
	const operacion = useWebTrackingStore(state => state.operacion)
	const referencia = useWebTrackingStore(state => state.referencia)
	const updateFechaInicio = useWebTrackingStore(state => state.updateFechaInicio)
	const updateFechaFin = useWebTrackingStore(state => state.updateFechaFin)
	const updateExpediente = useWebTrackingStore(state => state.updateExpediente)
	const updateReferencia = useWebTrackingStore(state => state.updateReferencia)
	const updateOperacion = useWebTrackingStore(state => state.updateOperacion)
	const updateEmbarque = useWebTrackingStore(state => state.updateEmbarque)
	

	const [disabledAll, setDisabledAll] = useState(true);
	

	useEffect(() => {
		setDisabledAll(cliente == '')
	  },[cliente, fechaInicio, fechaFin]);


	const handlerSearchClick = () => {
		props.onChange({
			cliente,
			fechaInicio,
			fechaFin,
			oficina,
			embarque,
			expediente,
			operacion,
			referencia
		});
	};

	const handlerExportClick = async () => {
		props.onExport({
			cliente,
			fechaInicio,
			fechaFin,
			oficina,
			embarque,
			expediente,
			operacion,
			referencia
		});
	};
	const handlerChangeDateRange = (selected:any) => {
		updateFechaInicio(selected.fechaInicio)
		updateFechaFin(selected.fechaFin)
	};
	const handlerChangeExpediente = (e:any) => {
		updateExpediente(e.target.value)
	};
	const handlerChangeReferencia = (e:any) => {
		updateReferencia(e.target.value)
	};
	const handlerChangeOperation = (selected:any) => {
		updateOperacion(selected)
	};
	const handlerChangeEmbarque = (selected:any) => {
		updateEmbarque(selected)
	};

	return (
		<FormControl>
		<Image src={tracking}  mb='10px'/>
				<SimpleGrid columns={{ sm: 1, md: 2 , xl: 3}} spacing={{ base: '15px', xl: '15px' }}>
					<DateRangeSelect onChangeSelection={handlerChangeDateRange} />
						
						<ClientesUsuarioSelect currentStorage={MODULO_WEB_TRACKING}  />

						<InputField mb='0px' me='30px' id='inputFilterExpediente' label='Expediente' value={expediente} onChange={handlerChangeExpediente} />

						<InputField mb='0px' me='30px' id='inputFilterReferencia' label='Referencia' value={referencia} onChange={handlerChangeReferencia} />

						<OficinaSelect  />

						<OperacionSelect onChange={handlerChangeOperation} includeGlobal selectedValue={operacion} />
						<EmbarqueSelect onChange={handlerChangeEmbarque} includeGlobal selectedValue={embarque} />

				</SimpleGrid>
                        <Flex flexDirection={{ base: 'column', md: 'row' }} mt='15px'>
						<LightMode>
				<Button
					colorScheme='green'
					variant='outline'
					p='15px 40px'
					fontSize='sm'
					onClick={handlerExportClick}
					isDisabled={disabledAll || props.disabledActions}
					fontWeight='500'
					ms={{ base: '0', md: 'auto' }}
					mb={{ base: '20px', md: '0' }}
					me={{ base: '0', md: '20px' }}
					_hover={{ bg: 'whiteAlpha.100' }}
					_focus={{ bg: 'transparent' }}
					_active={{ bg: 'transparent' }}>
					<Icon as={RiFileExcel2Line} width='20px' height='20px' color='inherit' mr='10px' /> Exportar a Excel
          <Spinner
              size='sm'
			  ml='5px'
			  hidden={!props.showProgressExport}
            />
				</Button>
			</LightMode>
                            <Button variant='brand' fontSize='sm' fontWeight='500' onClick={handlerSearchClick} isDisabled={disabledAll || props.disabledActions}>
							<Icon as={RiSearch2Line} width='20px' height='20px' color='inherit' mr='10px' /> Buscar
          <Spinner
              size='sm'
			  ml='5px'
			  hidden={!props.showProgressSearch}
            />
                            </Button>
                        </Flex>	
		</FormControl>
	);
}
